<template>
  <div class="about" style="text-align:center">
    <h1>用户中心页面</h1>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'User',
  components: {
  }
}
</script>
